<template>
  <div class="zoom-drag-block">
    <iframe id="turn-book" frameborder="0" :src="pdf">
    </iframe>
    <el-image
        ref="image__preview"
        style="width: 10px; height: 10px"
        class="no-show"
        :src="pdfImg[0]"
        :preview-src-list="pdfImg"
      ></el-image>
  </div>
</template>
<script>

// import DragMoveModel from './DragMoveModel'
import { mergePDFs, getBase64FromSinglePDF } from '@/utils'
import { mapGetters } from 'vuex'
let prefix = ''
export default {
  data () {
    return {
      model: null,
      pdf: '',
      pdfImg: [],
      loaded: {}
    }
  },
  props: {
    pages: Array,
    curPage: Number,
    zoom: Number
  },
  computed: {
    ...mapGetters(['library'])
  },
  mounted () {
    prefix = window.location.origin + window.location.pathname + `pdfjs-${this.library.docType}/web/viewer.html?file=`
    if (this.pages.length > 0) this.pdf = prefix + this.pages[0].url
    this.$bus.$on('downloadPdf', () => {
      // 使用a标签和download属性来触发文件下载
      let pdfUrl = this.pdf.split('file=')[1]
      const xhr = new XMLHttpRequest();
      xhr.open('GET', pdfUrl, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status === 200) {
          const blob = new Blob([xhr.response], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = pdfUrl.split('/').slice(-1);
          link.click();
          URL.revokeObjectURL(url);
        }
      };
      xhr.send();
    })
    // this.model = new DragMoveModel({ targetEl: document.getElementById('drag'), limitMoveBorder: false })
  },
  methods: {
    async preview () {
      let img = await getBase64FromSinglePDF(this.loaded['u' + this.curPage])
      this.pdfImg.push(img)
      if (this.curPage !== 1) {
        let nextImg = await getBase64FromSinglePDF(this.loaded['u' + this.curPage], 2)
        this.pdfImg.push(nextImg)
      }
      this.$refs.image__preview.clickHandler()
    }
  },
  beforeDestroy () { },
  watch: {
    pages (val) {
      let url = val[0].url
      this.pdf = prefix + url
    },
    async curPage (page) {
      if (this.pages[page - 1].url instanceof Array) {
        if (this.loaded['u' + page]) {
          this.pdf = prefix + this.loaded['u' + page]
        } else {
          let url = await mergePDFs(this.pages[page - 1].url)
          this.pdf = prefix + url
          this.loaded['u' + page] = url
        }
      } else {
        this.pdf = prefix + this.pages[page - 1].url
      }
    },
    zoom (val) {
      let oDiv = document.querySelector('.zoom-drag-block')
      oDiv.style.transform = 'scale(' + val / 100 + ')'; // scale()在这里要使用拼接的方式才能生效。
      oDiv.style.transformOrigin = '50% 50%';
    }
  }
}
</script>
<style lang="less">
@import "~@/styles/variables.less";
.zoom-drag-block {
  width: 100%;
  height: 100%;
}

#turn-book {
  width: 100%;
  height: 100%;
  cursor: grab;

  .hard {
    background: #ccc !important;
    color: #333;
  }

  .page {
    background-color: white;
    background-size: 200% 100%;
    background-repeat: no-repeat;
    background-position-x: 100%;

    &.fl {
      background-size: 100% 100%;
    }

    &.evenItem {
      background-position-x: 0%;
    }
  }
}
.no-show {
  display: none;
}
</style>
